export default {
  state: {
    isCollapse: false
  },
  mutations: {
    setCollapse(state, value) {
      state.isCollapse = value
    },
    changeCollapse(state) {
      state.isCollapse = !state.isCollapse
    }
  }
}